<ng-container>
  <div class="container-fluid">
    <div class="row justify-content-center pb-5">
      <div class="col-md-11 col-12">
        <div class="row mt-5 mb-3">
          <div class="col-md-7 col-12">
            <app-area-heading [heading]="layout.heading" [subheading]="layout.subheading"
              [backRoute]="layout.backRoute"></app-area-heading>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-9 col-12 mt-5">
            <div>
              <iframe title="Report Section" width="100%" height="700"
                src="https://app.powerbi.com/view?r=eyJrIjoiYmQ3MjBlMTQtMzM2ZS00YWZiLWI5Y2QtMGEzODI2ZGJkNzdiIiwidCI6Ijc3Y2I0NjVlLWNiMzItNDZlNC1iM2NjLWQ0M2QwYTU1YTkzNiJ9"
                frameborder="0" allowFullScreen="true">
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>